<template>
  <!-- MBR theme 2 frosted bottom navigation — member_app_UI/song_fa_members_member_home.
       MY QR opens #qrcode-modal-member: the host screen mounts <QrcodeMember /> when it hides the global Navbar. -->
  <nav class="mbr-bnav" :aria-label="$t('nav.main_navigation')">
    <div class="mbr-bnav__bar">
      <button
        type="button"
        class="mbr-bnav__item"
        :class="{ 'mbr-bnav__item--active': $route.name === 'Landing' }"
        @click="go('/home')"
      >
        <svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>
        <span>{{ $t('nav.home') }}</span>
      </button>

      <button
        type="button"
        class="mbr-bnav__item"
        :class="{
          'mbr-bnav__item--active': can('My Rewards') && isRewardsSection,
          'mbr-bnav__item--disabled': !can('My Rewards'),
        }"
        :disabled="!can('My Rewards')"
        :aria-disabled="!can('My Rewards')"
        @click="go('/my-rewards')"
      >
        <svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h17.25" /></svg>
        <span>{{ $t('nav.rewards') }}</span>
      </button>

      <div class="mbr-bnav__qr-wrap">
        <button
          type="button"
          class="mbr-bnav__qr"
          :aria-label="$t('nav.my_qr')"
          data-bs-toggle="modal"
          data-bs-target="#qrcode-modal-member"
        >
          <svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5zM15 15h1.5v1.5H15V15zm3 0h1.5v1.5H18V15zm-3 3h1.5v1.5H15V18zm3 3h1.5v1.5H18V21zM15 18h1.5v1.5H15V18zm0 3h1.5v1.5H15V21zm3-3h1.5v1.5H18V18z" /></svg>
        </button>
        <span class="mbr-bnav__qr-label">{{ $t('nav.my_qr') }}</span>
      </div>

      <button
        type="button"
        class="mbr-bnav__item"
        :class="{
          'mbr-bnav__item--active': can('Transactions') && $route.name === 'Transactions',
          'mbr-bnav__item--disabled': !can('Transactions'),
        }"
        :disabled="!can('Transactions')"
        :aria-disabled="!can('Transactions')"
        @click="go('/my-transactions')"
      >
        <svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        <span>{{ $t('nav.activity') }}</span>
      </button>

      <button
        type="button"
        class="mbr-bnav__item"
        :class="{ 'mbr-bnav__item--active': $route.name === 'Account' }"
        @click="go('/account')"
      >
        <svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" /></svg>
        <span>{{ $t('nav.account') }}</span>
      </button>
    </div>
  </nav>
</template>

<script>
import MemberService from "@/services/member.service";
import { getMerchantCode } from "@/config/utils";

export default {
  name: "MbrBottomNav",
  data() {
    return {
      // null until loaded: every item stays enabled rather than flashing disabled
      memberPermissions: null,
    };
  },
  created() {
    // same permission names the sidenav uses to show My Rewards / Transactions
    MemberService.checkMemberPermissions().then(
      (response) => {
        if (response.data.result.isSuccess) {
          this.memberPermissions = response.data.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  },
  computed: {
    // the Rewards section spans three tabs: My Vouchers, Catalogue and Store
    // ("Reward Catelogue" is the router's spelling)
    isRewardsSection() {
      return ["My Rewards", "Reward Catelogue", "Store"].includes(this.$route.name);
    },
  },
  methods: {
    can(permission) {
      return this.memberPermissions === null || this.memberPermissions.includes(permission);
    },
    go(path) {
      const code = getMerchantCode();
      this.$router.push((code ? `/${code}` : "") + path);
    },
  },
};
</script>

<style scoped>
/* below the slide-in sidenav (z-index 9999) and the modals */
.mbr-bnav {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 1030;
  width: 100%;
  max-width: 440px;
  /* no fixed gap under the bar: iOS Safari 26 already lifts bottom:0 above its floating toolbar (MBR097) */
  padding: 0 12px env(safe-area-inset-bottom, 0px);
  font-family: var(--mbr-font-body);
  transform: translateX(-50%);
  pointer-events: none;
}

/* Measured against code.html at 390px: bar 97.5px tall, items centred, QR button 11px above the bar */
.mbr-bnav__bar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px 12px;
  background: var(--mbr-nav-bg);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-xl);
  box-shadow: 0 -4px 25px rgba(var(--mbr-color-primary-rgb), 0.08);
  backdrop-filter: blur(var(--mbr-nav-blur));
  -webkit-backdrop-filter: blur(var(--mbr-nav-blur));
  pointer-events: auto;
}

.mbr-bnav__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 56px;
  padding: 0;
  background: none;
  border: 0;
  color: var(--mbr-color-ink-muted);
  transition: color 0.15s ease;
}

.mbr-bnav__item svg {
  width: 20px;
  height: 20px;
}

.mbr-bnav__item span {
  font-size: 9px;
  font-weight: 700;
  line-height: 13.5px;
  letter-spacing: 0.1em;
}

.mbr-bnav__item--active {
  color: var(--mbr-color-ink-headline);
}

/* design: the active icon's line weight thickens to 2.2px */
.mbr-bnav__item--active svg {
  stroke-width: 2.2;
}

.mbr-bnav__item--active span {
  font-weight: 800;
}

/* merchant turned the permission off: keep the slot so MY QR stays centred (MBR127) */
.mbr-bnav__item--disabled {
  cursor: default;
  opacity: 0.35;
}

/* like the design's `relative -top-5`: shifted up visually, its full height still sets the bar height */
.mbr-bnav__qr-wrap {
  position: relative;
  top: -20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mbr-bnav__qr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 0;
  background: var(--mbr-color-primary);
  border: 4px solid var(--mbr-color-canvas);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-on-primary);
  box-shadow: var(--mbr-shadow-qr);
  transition: transform 0.15s ease;
}

.mbr-bnav__qr:active {
  transform: scale(0.95);
}

.mbr-bnav__qr svg {
  width: 28px;
  height: 28px;
}

.mbr-bnav__qr-label {
  margin-top: 2px;
  font-size: 9px;
  font-weight: 800;
  line-height: 13.5px;
  letter-spacing: 0.05em;
  color: var(--mbr-color-primary);
}
</style>
